import styled from 'styled-components'

export const StyledWidget = styled.div`
`
